// extracted by mini-css-extract-plugin
export default {"white":"#ffffff","trout":"#4a5161","linkWater":"#f1f4fb","toggleMobileMenu":"styles_toggleMobileMenu__dypH7","burger":"styles_burger__wtpuv","cross":"styles_cross__DALMk"};